import React from "react";
import { useSelector } from "react-redux";
import { LANDSCAPE } from "../../../config/Constant";
import InfoWidget_potrait from "./infoWidget_potrait";
import InfoWidget_landscape from "./infoWidget_landscape";



export const InfoWidget = (props) => {
    const { appOrientation } = useSelector(state => (state.appConfigSlice));

    if (appOrientation == LANDSCAPE) {
        return <InfoWidget_landscape {...props} />;
    } else {
        return <InfoWidget_potrait {...props} />;
    }
}

